var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyerAgreementTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10.3701C2 5.95184 5.58172 2.37012 10 2.37012C14.4183 2.37012 18 5.95184 18 10.3701C18 14.7884 14.4183 18.3701 10 18.3701C5.58172 18.3701 2 14.7884 2 10.3701ZM10 0.370117C4.47715 0.370117 0 4.84727 0 10.3701C0 15.893 4.47715 20.3701 10 20.3701C15.5228 20.3701 20 15.893 20 10.3701C20 4.84727 15.5228 0.370117 10 0.370117ZM14.8153 8.84367C15.2149 8.46244 15.2298 7.82945 14.8486 7.42985C14.4673 7.03024 13.8343 7.01534 13.4347 7.39657L8.62246 11.9875L6.56589 10.0222C6.1666 9.64059 5.5336 9.65495 5.15204 10.0542C4.77047 10.4535 4.78483 11.0865 5.18411 11.4681L7.93099 14.0931C8.31728 14.4622 8.92554 14.4625 9.31215 14.0937L14.8153 8.84367Z",
    fill: "#4A4C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyerAgreementTick);
export default __webpack_public_path__ + "static/media/BuyerAgreementTick.57204f34c42def4447f9213007f6035c.svg";
export { ForwardRef as ReactComponent };